module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_EN.0c144a50.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsCookieNotice_EN.pdf
// module id = 286
// module chunks = 4